
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg-icon",classNames,staticClass],
              style: [{"width":"1em","height":"1em","vertical-align":"middle"},style,staticStyle],
              attrs: Object.assign({"style":"width:1em;height:1em;vertical-align:middle","viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","overflow":"hidden"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M512 554.667a63.573 63.573 0 00-42.667 111.36v59.306a42.667 42.667 0 0085.334 0v-59.306A63.573 63.573 0 00512 554.667zM725.333 384v-85.333a213.333 213.333 0 00-426.666 0V384a128 128 0 00-128 128v298.667a128 128 0 00128 128h426.666a128 128 0 00128-128V512a128 128 0 00-128-128zM384 298.667a128 128 0 01256 0V384H384zm384 512a42.667 42.667 0 01-42.667 42.666H298.667A42.667 42.667 0 01256 810.667V512a42.667 42.667 0 0142.667-42.667h426.666A42.667 42.667 0 01768 512z","fill":"#fff"}})])
          )
        }
      }
    